import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import "./Blog.css";
import { BACKEND_URL } from "../../../config";

const toSlug = (str = "") =>
  str.toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

function Blog() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    setDataLoaded(false);

    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api.php?module=blog`);
        const data = await res.json();

        if (data?.success) {
          setBlogs(data.data);
        } else {
          setBlogs([]);
        }
      } catch (error) {
        console.log(error);
        setBlogs([]);
      } finally {
        setDataLoaded(true);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="blog-page">
      <Helmet>
        <title>{blogs?.metaTitle}</title>
        <meta name="description" content={blogs?.metaDescription} />
        <meta name="keywords" content={blogs?.keywords} />
        <link rel="canonical" href="https://realgenericshop.com/blog" />
      </Helmet>

      <div className="blog-heading">
        <h1>Recent Blogs</h1>
        <p>Read latest healthcare articles & updates</p>
      </div>

      <div className="blog-grid">
        {!dataLoaded ? null : blogs.length > 0 ? (
          blogs.map((b) => (
            <div className="blog-card" key={b.id}>
              <div
                className="blog-image-box"
                onClick={() => navigate(`/blog/${toSlug(b.title)}`)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={b.image?.startsWith("http") ? b.image : `${BACKEND_URL}/${b.image}`}
                  alt={b.title}
                  className="blog-image"
                />
              </div>
              <div className="blog-content">
                <h4
                  onClick={() => navigate(`/blog/${toSlug(b.title)}`)}
                  style={{ cursor: "pointer" }}
                >
                  {b.title}
                </h4>
                <span className="blog-date">
                  <FaCalendarAlt className="blog-date-icon" />
                  {b.date}
                </span>
                <button
                  className="btn"
                  onClick={() => navigate(`/blog/${toSlug(b.title)}`)}
                >
                  Read More
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-blog">
            <h2>No Blogs Found</h2>
          </div>
        )}
      </div>
    </div>
  );
}

export default Blog;